class DocumentLink extends HTMLElement {
  constructor() {
    super();
    this.configuration = null;
    this.linkContainer = this.querySelector("[data-links] tbody");
    try {
      this.configuration = JSON.parse(this.querySelector('[data-configuration]').innerText);
    } catch(e) {
      console.error(e);
    }
  }

  async connectedCallback() {
    if (this.configuration == null) return;
    
    const {url, token, shopify_domain, shopify_order_id} = this.configuration;
    let {documents} = this.configuration;

    documents = documents.map((document) => {
      /**
       * Since there can be many of the same type
       * of Document: document_key has the document_type + id,
       * so we can use that to fetch the correct Document
       */
      const {document_key} = document;
      const body = {
        shopify_domain,
        shopify_order_id,
        document_type: document_key,
      };
      const fetchDocumentPromise = fetch(url, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": token
        },
        method: 'PUT',
        body: JSON.stringify(body)
      });
      return {
        ...document,
        document_file: fetchDocumentPromise
      }
    });
    
    documents.forEach(async (document) => {
      document.document_file = await document.document_file;
      document.document_file = await document.document_file.text();
      if (!/^we could not find/.test(document.document_file)) {
        this.appendDocument(document);
        this.classList.remove('hidden');
      }
    });
    
    // this.appendDocument({
    //   sap_id: 'test',
    //   document_type: 'test',
    //   document_file: 'test'
    // });
    // this.appendDocument({
    //   sap_id: 'test',
    //   document_type: 'test',
    //   document_file: 'test'
    // });
    
    // this.classList.remove('hidden');
  }
  
  appendDocument(document) {
    const {shopify_order_id} = this.configuration;
    const html = `
      <tr class="ta-l">
        <td scope="row" data-label="${this.configuration.i18n.nr}">${document.sap_id}</td>
        <td scope="row" data-label="${this.configuration.i18n.type}">${this.translateDocumentType(document.document_type)}</td>
        <td scope="row" data-label="${this.configuration.i18n.download_label}"><a download="${document.document_type}_${shopify_order_id}_${document.sap_id}" target="_blank" href="data:application/pdf;base64,${document.document_file}">${this.configuration.i18n.download}</a></td>
      </tr>`;
    this.linkContainer.insertAdjacentHTML('beforeend', html);
  }

  translateDocumentType(documentType) {
    if (!documentType) return;

    switch(documentType.toLowerCase()) {
      case 'ls':
        return 'lieferschein'
      case 'ab':
        return 'auftragsbestätigung'
      case 're':
        return 'rechnung'
    }

    return documentType;
  }
}

customElements.define('document-link', DocumentLink );